var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "80px",
    height: "80px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#f5f5f5",
    d: "M 59.5,23.5 C 62.1667,23.5 64.8333,23.5 67.5,23.5C 67.6664,32.5062 67.4998,41.5062 67,50.5C 64.882,54.825 61.382,56.825 56.5,56.5C 52.03,55.5139 47.3633,55.1805 42.5,55.5C 42.5,53.1667 42.5,50.8333 42.5,48.5C 48.2124,48.687 53.8791,48.3537 59.5,47.5C 59.5,39.5 59.5,31.5 59.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.243
    },
    fill: "#c5c5c6",
    d: "M 11.5,23.5 C 11.5,26.1667 11.5,28.8333 11.5,31.5C 20.8333,31.5 30.1667,31.5 39.5,31.5C 39.5,28.8333 39.5,26.1667 39.5,23.5C 40.4767,26.2869 40.81,29.2869 40.5,32.5C 30.5,32.5 20.5,32.5 10.5,32.5C 10.19,29.2869 10.5233,26.2869 11.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#f8f8f8",
    d: "M 11.5,23.5 C 20.8333,23.5 30.1667,23.5 39.5,23.5C 39.5,26.1667 39.5,28.8333 39.5,31.5C 30.1667,31.5 20.8333,31.5 11.5,31.5C 11.5,28.8333 11.5,26.1667 11.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#eaeaea",
    d: "M 21.5,34.5 C 23.9946,34.9688 26.6613,34.9688 29.5,34.5C 29.5,41.8333 29.5,49.1667 29.5,56.5C 26.5525,56.7771 23.7191,56.4438 21,55.5C 20.2055,48.4197 20.3722,41.4197 21.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.47
    },
    fill: "#c9c9c9",
    d: "M 59.5,23.5 C 59.5,31.5 59.5,39.5 59.5,47.5C 53.8791,48.3537 48.2124,48.687 42.5,48.5C 42.5,50.8333 42.5,53.1667 42.5,55.5C 47.3633,55.1805 52.03,55.5139 56.5,56.5C 51.5,56.5 46.5,56.5 41.5,56.5C 41.5,53.5 41.5,50.5 41.5,47.5C 46.1785,47.6658 50.8452,47.4992 55.5,47C 56.4162,46.6258 57.2496,46.1258 58,45.5C 58.1712,37.9885 58.6712,30.6552 59.5,23.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.4debbb0dfcab60c4e87fb27fad5ceb21.svg";
export { ForwardRef as ReactComponent };